// extracted by mini-css-extract-plugin
export default {"block":"Jj","image":"Kj","item":"Lj","error":"Mj"};